"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lte = exports.lt = exports.gte = exports.gt = exports.neq = exports.eq = exports.setYear = exports.setMonth = exports.setDate = exports.setDay = exports.setHours = exports.setMinutes = exports.setSeconds = exports.setMilliseconds = exports.getYear = exports.getMonth = exports.getDate = exports.getDay = exports.getHours = exports.getMinutes = exports.getSeconds = exports.getMilliseconds = void 0;
exports.getWeekday = getWeekday;
exports.add = add;
exports.setWeekday = setWeekday;
exports.subtract = subtract;
exports.startOf = startOf;
exports.getDecade = getDecade;
exports.setDecade = setDecade;
exports.getCentury = getCentury;
exports.setCentury = setCentury;
exports.endOf = endOf;
exports.min = min;
exports.max = max;
exports.inRange = inRange;
exports.inArray = inArray;
exports.diff = diff;
function createAccessor(method) {
    return function (date) {
        return date['get' + method]();
    };
}
function createSetter(method) {
    return function (date, val) {
        date = date ? new Date(date.valueOf()) : new Date();
        date['set' + method](val);
        return date;
    };
}
exports.getMilliseconds = createAccessor('Milliseconds');
exports.getSeconds = createAccessor('Seconds');
exports.getMinutes = createAccessor('Minutes');
exports.getHours = createAccessor('Hours');
exports.getDay = createAccessor('Day');
exports.getDate = createAccessor('Date');
exports.getMonth = createAccessor('Month');
exports.getYear = createAccessor('FullYear');
function getWeekday(date, firstDay = 0) {
    return ((0, exports.getDay)(date) + 7 - firstDay) % 7;
}
exports.setMilliseconds = createSetter('Milliseconds');
exports.setSeconds = createSetter('Seconds');
exports.setMinutes = createSetter('Minutes');
exports.setHours = createSetter('Hours');
exports.setDay = createSetter('Day');
exports.setDate = createSetter('Date');
exports.setMonth = createSetter('Month');
exports.setYear = createSetter('FullYear');
function addMath(date, val) {
    const current = (0, exports.getMonth)(date);
    let newMonth = (current + val);
    date = (0, exports.setMonth)(date, newMonth);
    if (newMonth < 0) {
        newMonth = 12 + newMonth % 12;
    }
    if ((0, exports.getMonth)(date) !== (newMonth % 12)) {
        date = (0, exports.setDate)(date, 0);
    }
    return date;
}
function add(date, num, unit) {
    date = date ? new Date(date.valueOf()) : new Date();
    switch (unit) {
        case 'milliseconds':
            return (0, exports.setMilliseconds)(date, (0, exports.getMilliseconds)(date) + num);
        case 'seconds':
            return (0, exports.setSeconds)(date, (0, exports.getSeconds)(date) + num);
        case 'minutes':
            return (0, exports.setMinutes)(date, (0, exports.getMinutes)(date) + num);
        case 'hours':
            return (0, exports.setHours)(date, (0, exports.getHours)(date) + num);
        case 'year':
            return (0, exports.setYear)(date, (0, exports.getYear)(date) + num);
        case 'day':
            return (0, exports.setDate)(date, (0, exports.getDate)(date) + num);
        case 'week':
            return (0, exports.setDate)(date, (0, exports.getDate)(date) + (7 * num));
        case 'month':
            return addMath(date, num);
        case 'decade':
            return (0, exports.setYear)(date, (0, exports.getYear)(date) + (num * 10));
        case 'century':
            return (0, exports.setYear)(date, (0, exports.getYear)(date) + (num * 100));
    }
    throw new TypeError('Invalid units: "' + unit + '"');
}
function setWeekday(date, val, firstDay = 0) {
    const weekday = ((0, exports.getDay)(date) + 7 - firstDay) % 7;
    return add(date, val - weekday, 'day');
}
function subtract(date, num, unit) {
    return add(date, -num, unit);
}
function startOf(date, unit, firstOfWeek) {
    date = date ? new Date(date.valueOf()) : new Date();
    switch (unit) {
        case 'century':
        case 'decade':
        case 'year':
            date = (0, exports.setMonth)(date, 0);
        case 'month':
            date = (0, exports.setDate)(date, 1);
        case 'week':
        case 'day':
            date = (0, exports.setHours)(date, 0);
        case 'hours':
            date = (0, exports.setMinutes)(date, 0);
        case 'minutes':
            date = (0, exports.setSeconds)(date, 0);
        case 'seconds':
            date = (0, exports.setMilliseconds)(date, 0);
    }
    if (unit === 'decade') {
        date = subtract(date, (0, exports.getYear)(date) % 10, 'year');
    }
    if (unit === 'century') {
        date = subtract(date, (0, exports.getYear)(date) % 100, 'year');
    }
    if (unit === 'week') {
        date = setWeekday(date, 0, firstOfWeek);
    }
    return date;
}
function getDecade(date) {
    return (0, exports.getYear)(startOf(date, 'decade'));
}
function setDecade(date, val) {
    return add(date, val + 10, 'year');
}
function getCentury(date) {
    return (0, exports.getYear)(startOf(date, 'century'));
}
function setCentury(date, val) {
    return add(date, val + 100, 'year');
}
function createComparer(operator) {
    return function (a, b, unit) {
        return operator(+startOf(a, unit), +startOf(b, unit));
    };
}
function endOf(date, unit, firstOfWeek) {
    date = date ? new Date(date.valueOf()) : new Date();
    date = startOf(date, unit, firstOfWeek);
    date = add(date, 1, unit);
    date = subtract(date, 1, 'milliseconds');
    return date;
}
exports.eq = createComparer((a, b) => a === b);
exports.neq = createComparer((a, b) => a !== b);
exports.gt = createComparer((a, b) => a > b);
exports.gte = createComparer((a, b) => a >= b);
exports.lt = createComparer((a, b) => a < b);
exports.lte = createComparer((a, b) => a <= b);
function min(...dates) {
    return new Date(Math.min(...dates.map((date) => date.valueOf())));
}
function max(...dates) {
    return new Date(Math.max(...dates.map((date) => date.valueOf())));
}
function inRange(day, minValue, maxValue, unit = 'day') {
    return (!minValue || (0, exports.gte)(day, minValue, unit)) && (!maxValue || (0, exports.lte)(day, maxValue, unit));
}
function inArray(day, blackListDates) {
    return blackListDates ? (blackListDates.find((x) => {
        return x.getUTCFullYear() === (day).getUTCFullYear() && x.getUTCMonth() === (day).getUTCMonth() && x.getUTCDate() === (day).getUTCDate();
    })) !== undefined : false;
}
function absoluteFloor(number) {
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function diff(date1, date2, unit, asFloat = true) {
    let dividend;
    let divisor;
    switch (unit) {
        case 'milliseconds':
        case 'seconds':
        case 'minutes':
        case 'hours':
        case 'day':
        case 'week':
            dividend = date2.getTime() - date1.getTime();
            break;
        case 'month':
        case 'year':
        case 'decade':
        case 'century':
            dividend = ((0, exports.getYear)(date2) - (0, exports.getYear)(date1)) * 12 + (0, exports.getMonth)(date2) - (0, exports.getMonth)(date1);
            break;
        default:
            throw new TypeError('Invalid units: "' + unit + '"');
    }
    switch (unit) {
        case 'milliseconds':
            divisor = 1;
            break;
        case 'seconds':
            divisor = 1000;
            break;
        case 'minutes':
            divisor = 1000 * 60;
            break;
        case 'hours':
            divisor = 1000 * 60 * 60;
            break;
        case 'day':
            divisor = 1000 * 60 * 60 * 24;
            break;
        case 'week':
            divisor = 1000 * 60 * 60 * 24 * 7;
            break;
        case 'month':
            divisor = 1;
            break;
        case 'year':
            divisor = 12;
            break;
        case 'decade':
            divisor = 120;
            break;
        case 'century':
            divisor = 1200;
            break;
        default:
            throw new TypeError('Invalid units: "' + unit + '"');
    }
    const result = dividend / divisor;
    return asFloat ? result : absoluteFloor(result);
}
exports.default = {
    getMilliseconds: exports.getMilliseconds,
    getSeconds: exports.getSeconds,
    getMinutes: exports.getMinutes,
    getHours: exports.getHours,
    getDay: exports.getDay,
    getDate: exports.getDate,
    getMonth: exports.getMonth,
    getYear: exports.getYear,
    getWeekday,
    setMilliseconds: exports.setMilliseconds,
    setSeconds: exports.setSeconds,
    setMinutes: exports.setMinutes,
    setHours: exports.setHours,
    setDay: exports.setDay,
    setDate: exports.setDate,
    setMonth: exports.setMonth,
    setYear: exports.setYear,
    add,
    setWeekday,
    subtract,
    startOf,
    getDecade,
    setDecade,
    getCentury,
    setCentury,
    endOf,
    eq: exports.eq,
    neq: exports.neq,
    gt: exports.gt,
    gte: exports.gte,
    lt: exports.lt,
    lte: exports.lte,
    min,
    max,
    inRange,
    inArray,
    diff
};
//# sourceMappingURL=date-arithmetic.js.map